import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { IReceivedMessageCaleGroupingsProps } from "../models";
import { calendarConsultationGroupingRegisterList } from "../../../../../../../services/calendarConsultationGroupingRegister.service";
import { calendarExamGroupingRegisterList } from "../../../../../../../services/calendarExamGroupingRegister.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedMessages.";

export const ReceivedMessageCaleGroupings = memo(
  ({ automationCode }: IReceivedMessageCaleGroupingsProps) => {
    const { t } = useTranslation();

    const { sendRequest: consultationGroupingRegisterRequest } = useFetch(
      calendarConsultationGroupingRegisterList,
    );

    const { sendRequest: examGroupingRegisterRequest } = useFetch(
      calendarExamGroupingRegisterList,
    );

    const [
      optionsConsultationGroupingRegister,
      setOptionsConsultationGroupingRegister,
    ] = useState<ISelectType[]>([]);

    const params = useMemo(() => {
      return { EnableCode: true };
    }, []);

    const fetchConsultationGroupingRegister = useCallback(async () => {
      let data;
      let success;
      if (automationCode === "20") {
        ({ data, success } = await examGroupingRegisterRequest(params));
      } else {
        ({ data, success } = await consultationGroupingRegisterRequest(params));
      }
      if (data && success) {
        setOptionsConsultationGroupingRegister(
          data.map((d) => ({
            id: d.groupingIdentifier.toString(),
            name: d.groupingName,
          })),
        );
      }
    }, [consultationGroupingRegisterRequest]);

    useEffect(() => {
      fetchConsultationGroupingRegister();
    }, [fetchConsultationGroupingRegister]);

    return (
      <Grid item xs={12} sm={12}>
        <AutoCompleteMulti
          params={params}
          fullWidth
          options={optionsConsultationGroupingRegister}
          name="calendarConsultationGroupingRegister"
          label={t(translationPath + "consultation_grouping_register")}
          getOptionLabel={(option) => option.name}
          size="small"
          keepOpenOnSelect
        />
      </Grid>
    );
  },
);
